import React from 'react';
import {Grid} from "@mui/material";
import type {BookedSpaceCalendarView} from "../types/BookedSpaceCalendarView";
import SpaceUsageItem from "./spaceUsage/supplier/SpaceUsageItem";

interface SpaceUsageItemsListProps {
  spaceUsageItems: BookedSpaceCalendarView[];
  onViewOverageInvoices: () => void;
}

const SpaceUsageItemsList = (props: SpaceUsageItemsListProps) => {
  const {spaceUsageItems, onViewOverageInvoices} = props;
  return (
    <Grid item container rowGap={'0.36rem'}>
      {
        spaceUsageItems.map((item) =>
          <SpaceUsageItem
            data={item}
            key={item.id}
            onViewOverageInvoices={onViewOverageInvoices}/>
        )
      }
    </Grid>
  );
};

export default SpaceUsageItemsList;
